import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetSpeciesGroupsInputDto, SpeciesGroupCreateDto, SpeciesGroupDto, SpeciesGroupExcelDownloadDto, SpeciesGroupUpdateDto } from '../dtos/species-group/models';

@Injectable({
  providedIn: 'root',
})
export class SpeciesGroupService {
  private restService = inject(RestService);
  apiName = 'General';
  

  create = (input: SpeciesGroupCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpeciesGroupDto>({
      method: 'POST',
      url: '/api/general/speciesGroups',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/general/speciesGroups/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/general/speciesGroups',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpeciesGroupDto>({
      method: 'GET',
      url: `/api/general/speciesGroups/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/general/speciesGroups/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetSpeciesGroupsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<SpeciesGroupDto>>({
      method: 'GET',
      url: '/api/general/speciesGroups',
      params: { name: input.name, code: input.code, density: input.density, densityFrom: input.densityFrom, densityTo: input.densityTo, sapWoodMaterialId: input.sapWoodMaterialId, finalProductId: input.finalProductId, finalProductName: input.finalProductName, standardHumidityPercentage: input.standardHumidityPercentage, standardHumidityPercentageFrom: input.standardHumidityPercentageFrom, standardHumidityPercentageTo: input.standardHumidityPercentageTo, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: SpeciesGroupExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/general/speciesGroups/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, density: input.density, densityFrom: input.densityFrom, densityTo: input.densityTo, sapWoodMaterialId: input.sapWoodMaterialId, finalProductId: input.finalProductId, finalProductName: input.finalProductName, standardHumidityPercentage: input.standardHumidityPercentage, standardHumidityPercentageFrom: input.standardHumidityPercentageFrom, standardHumidityPercentageTo: input.standardHumidityPercentageTo, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpeciesGroupDto[]>({
      method: 'GET',
      url: '/api/general/speciesGroups/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: SpeciesGroupUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpeciesGroupDto>({
      method: 'PUT',
      url: `/api/general/speciesGroups/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}